import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { SecuritySchemaCommandFactory } from 'components/SecuritySchema/model/SecuritySchemaModel';
import { isRuleChainScope } from 'components/SecuritySchema/model/SecuritySchemaScope';
import { getRuleChainInitialPage } from 'components/SecuritySchema/model/helpers/getRuleChainInitialPage';

interface NavigateToBreadcrumbCommand {
  index: number;
}

export const navigateToBreadcrumb: SecuritySchemaCommandFactory<
  NavigateToBreadcrumbCommand
> = (cmdContext) => (command) => {
  // Fixed noUncheckedIndexedAccess NIM-19408
  const breadcrumb = cmdContext.getState().breadcrumbs[command.index]!;
  cmdContext.updateState((draft) => {
    if (!isRuleChainScope(draft.scope)) {
      stumble('Cannot open rule chain when no rule chain scope is active');
      return;
    }
    draft.breadcrumbs.splice(command.index);
    draft.scope.name = breadcrumb.ruleChainName;
    draft.scope.securityType = breadcrumb.securityType;
    draft.scope.scrollPosition = breadcrumb.scrollPosition;
    draft.page = breadcrumb.page ?? getRuleChainInitialPage(draft);
  });
};
